/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendDanceReminderRequest
 */
export interface SendDanceReminderRequest {
    /**
     * 
     * @type {string}
     * @memberof SendDanceReminderRequest
     */
    message: string | null;
}

/**
 * Check if a given object implements the SendDanceReminderRequest interface.
 */
export function instanceOfSendDanceReminderRequest(value: object): value is SendDanceReminderRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SendDanceReminderRequestFromJSON(json: any): SendDanceReminderRequest {
    return SendDanceReminderRequestFromJSONTyped(json, false);
}

export function SendDanceReminderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendDanceReminderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function SendDanceReminderRequestToJSON(json: any): SendDanceReminderRequest {
    return SendDanceReminderRequestToJSONTyped(json, false);
}

export function SendDanceReminderRequestToJSONTyped(value?: SendDanceReminderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

